import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { MessageService } from 'primeng/api';
import { ApiService } from '../../../services/api.service';
import { environment } from '../../../../environments/environment';
import { FileUpload } from 'primeng/fileupload';
import { Subscription } from 'rxjs';


@Component({
  selector: 'app-upload-doc',
  standalone: false,
  templateUrl: './upload-doc.component.html',
  styleUrl: './upload-doc.component.scss'
})
export class UploadDocComponent implements OnInit, OnDestroy {
  @Output() stepCompleted = new EventEmitter<void>();
  @Input() step: any;
  @Input() id: any
  @Input() getUrl1: any
  @Input() postUrl1: any
  @Output() IRA: EventEmitter<any> = new EventEmitter();
  @Output() generatePDFEmitter: EventEmitter<any> = new EventEmitter();
  @Input() isEditable: boolean = false;
  @Input() stepDetails: any;
  vendors: any
  @Input() schemeType: any;
  apiUrl = environment.APIUrl + '/'
  criteria = [];

  payload: {
    proposal_id: any;
    proposal_name: any;
    schemeId: any;
  };
  eoiData: any;
  selectedFileNames: { [vendorId: number]: { [criteriaName: string]: string } } = {};
  uploadedFileUrls: { [key: string]: string } = {};
  selectedFiles: { [vendorId: number]: { [criteriaName: string]: File } } = {};
  @ViewChild('fileUploader') fileUploader: FileUpload;
  uploadedDocsMap: { [vendorId: number]: { [criteriaName: string]: string | null } } = {};
  documentMap: {
    [vendorId: number]: {
      [criteriaName: string]: {
        docId: number;
        url: string;
      };
    };
  } = {};
  private subscriptions = new Subscription();
  userID: any;
  constructor(private messageService: MessageService, private fb: FormBuilder, private api: ApiService, private route: ActivatedRoute) {
      const role = sessionStorage.getItem('user_role_id');
    this.userID = role

  }

  ngOnInit(): void {
    this.route.queryParams.subscribe((params: any) => {
      const proposalId = params['id'];
      const proposalName = params['name'];
      const schemeId = params['scheme']
      this.payload = {
        proposal_id: proposalId,
        proposal_name: proposalName,
        schemeId: schemeId
      }
      // this.getStep1();
      this.getCriteriaList();
      if (this.schemeType != 'makeI') {
        this.getVendorIdentification();
      }
      this.getEOIDocs();
    });

  }
  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }
  goToNextStep() {
    this.stepCompleted.emit();
  }
  getStep1() {
    const sub = this.api.getAPI(this.getUrl1 + this.id + '&proposal_step__proposal=' + this.payload.proposal_id).subscribe((res: any) => {
      this.eoiData = res[0];

    })
    this.subscriptions.add(sub);
  }
  getVendorIdentification() {
    const sub = this.api.getAPI(`/revenue/vendor-identification/?proposal_step__proposal=${this.payload.proposal_id}`).subscribe((res: any) => {
      this.vendors = res.data
    });
    this.subscriptions.add(sub);
  }
  getCriteriaList() {
    let url;
    if(this.schemeType == 'makeI' || this.schemeType == 'makeII' || this.schemeType == 'makeIII'){
url = `/make1/eol-details/?proposal_step__proposal=${this.payload.proposal_id}`
    }else{
      url = `/revenue/eol-details/?proposal_step__proposal=${this.payload.proposal_id}`
    }
    const sub = this.api.getAPI(url).subscribe((res: any) => {
      this.criteria = res[0]?.criteria_list
    });
     this.subscriptions.add(sub);
  }

uploadFile(event: any, vendorId: number, criteriaName: string, id: any) {
  const normalizedName = criteriaName.trim().toLowerCase();

  const file = this.selectedFiles[vendorId]?.[normalizedName];

  if (!file) {
    console.warn("No file found. Did you select it for this criteria?");
    return;
  }

  const formData = new FormData();
  formData.append('proposal_step', this.id);
  formData.append('name', criteriaName);
  formData.append('vendor_id', vendorId.toString());
  formData.append('document_flag', 'true');
  formData.append('document', file);

  const apiPath = this.schemeType === 'makeI'
    ? `/make1/shorlisting/da/${id}/`
    : `/revenue/eol-documents/${id}/`;

  // const apiPath = `/revenue/eol-documents/${id}/`;

  const sub = this.api.putAPI(apiPath, formData).subscribe({
    next: (res) => {
      this.getEOIDocs();
      this.selectedFiles = {}
       this.fileUploader.clear();
      this.messageService.add({ severity: 'success', summary: 'Upload Successful', detail: criteriaName });
    },
    error: (err) => {
      console.error('Upload failed', err);
      this.messageService.add({ severity: 'error', summary: 'Upload Failed', detail: criteriaName });
    }
  });

  this.subscriptions.add(sub);
}
manualUpload(vendorId: number, criteriaName: string): void {
  const normalizedName = criteriaName.trim().toLowerCase();
  const file = this.selectedFiles[vendorId]?.[normalizedName];
  const docId = this.documentMap[vendorId]?.[normalizedName]?.docId || null;

  if (!file) {
    this.messageService.add({ severity: 'warn', summary: 'No File Selected', detail: `Please attach a file for ${criteriaName}` });
    console.warn('No file selected for vendor:', vendorId, 'criteria:', normalizedName);
    return;
  }

  this.uploadFile({}, vendorId, criteriaName, docId);
}


  @ViewChildren('fileUploader') fileUploaders!: QueryList<FileUpload>;

  triggerUpload(vendorId: number): void {
    const uploader = this.fileUploaders.find((uploaderComponent: any) => {
      const nativeEl: HTMLElement = uploaderComponent.el.nativeElement;
      return nativeEl.getAttribute('data-vendor-id') === vendorId.toString();
    });

    if (uploader) {
      uploader.upload(); // Triggers uploadHandler
    } else {
      console.warn('Uploader not found for vendor', vendorId);
    }
  }

  onFileSelect(event: any, vendorId: number, criteriaName: string): void {
    const file: File = event.files[0];
    if (!this.selectedFiles[vendorId]) {
      this.selectedFiles[vendorId] = {};
    }
    const normalizedName = criteriaName.trim().toLowerCase();
    this.selectedFiles[vendorId][normalizedName] = file;

    // this.selectedFiles[vendorId][criteriaName] = file;
    // console.log(this.selectedFiles[vendorId][normalizedName]); // ✅ should log the file correctly

  }

  getButtonLabel(vendorId: number, criteriaName: string): string {
    return this.selectedFiles[vendorId]?.[criteriaName] ? 'Upload' : 'Attach';
  }
  getSelectedFileName(vendorId: number, criteriaName: string): string {
    const criteriaKey = criteriaName.trim().toLowerCase();

    const docEntry = this.documentMap[vendorId]?.[criteriaKey];
    if (docEntry && docEntry.url) {
      const parts = docEntry.url.split('/');
      return parts[parts.length - 1]; // Extracts file name from URL
    }

    return '';
  }

  // triggerUpload(fileUploader: any) {
  //   fileUploader.upload();
  // }

  // getEOIDocs() {
  //   const url = this.schemeType == 'makeI'
  //     ? `/make1/shorlisting/da/?proposal_step__proposal=${this.payload.proposal_id}&proposal_step=${this.id}&scheme=${this.payload.schemeId}`
  //     : `/revenue/eol-documents/?proposal_step__proposal=${this.payload.proposal_id}&proposal_step=${this.id}`;

  //   //  const url = `/revenue/eol-documents/?proposal_step__proposal=${this.payload.proposal_id}&proposal_step=${this.id}`;

  //   const sub = this.api.getAPI(url).subscribe((res: any) => {

  //     // const map: { [vendorId: number]: { [criteriaName: string]: string | null } } = {};
  //     const map: {
  //       [vendorId: number]: {
  //         [criteriaName: string]: {
  //           docId: number;
  //           url: string;
  //         };
  //       };
  //     } = {};


  //     if (this.schemeType === 'makeI') {
  //       const vendorMap = new Map();

  //       Object.keys(res).forEach((vendorName: string) => {
  //         const docs = res[vendorName];

  //         docs.forEach((doc: any) => {
  //           // console.log(doc)
  //           const vendorId = doc.da?.id || doc.vendor?.id;
  //           const criteriaName = doc.name?.trim().toLowerCase();

  //           if (!vendorId || !criteriaName) return;

  //           if (!map[vendorId]) {
  //             map[vendorId] = {};
  //           }
  //           map[vendorId][criteriaName] = {
  //             docId: doc.id,
  //             url: doc.document || ''
  //           };

  //           if (!vendorMap.has(vendorId)) {
  //             vendorMap.set(vendorId, {
  //               vendor: {
  //                 id: vendorId,
  //                 name: vendorName
  //               }
  //             });
  //           }
  //         });
  //       });

  //       this.vendors = Array.from(vendorMap.values());
  //     } else {
  //       for (const vendorName in res) {
  //         const docs = res[vendorName];

  //         docs.forEach((doc: any) => {
  //           // console.log(doc)
  //           const vendorId = doc.vendor.id;
  //           const criteriaName = doc.name?.trim().toLowerCase();

  //           if (!vendorId || !criteriaName) return;

  //           if (!map[vendorId]) {
  //             map[vendorId] = {};
  //           }
  //           map[vendorId][criteriaName] = {
  //             docId: doc.id,
  //             url: doc.document || ''
  //           };
  //         });
  //       }
  //     }

  //     // ✅ Final assignment after all processing
  //     this.documentMap = map;
  //     console.log("doc" , this.documentMap)
  //   });
  //   this.subscriptions.add(sub);
  // }
  getEOIDocs() {
  const normalizeKey = (s: string) =>
    s?.replace(/\r?\n|\r/g, ' ') // remove line breaks
      ?.replace(/\s+/g, ' ')     // collapse multiple spaces
      ?.trim()
      ?.toLowerCase();

  const url = this.schemeType === 'makeI'
    ? `/make1/shorlisting/da/?proposal_step__proposal=${this.payload.proposal_id}&proposal_step=${this.id}&scheme=${this.payload.schemeId}`
    : `/revenue/eol-documents/?proposal_step__proposal=${this.payload.proposal_id}&proposal_step=${this.id}`;

  const sub = this.api.getAPI(url).subscribe((res: any) => {
    const map: {
      [vendorId: number]: {
        [criteriaName: string]: {
          docId: number;
          url: string;
        };
      };
    } = {};

    if (this.schemeType === 'makeI') {
      const vendorMap = new Map();

      Object.keys(res).forEach((vendorName: string) => {
        const docs = res[vendorName];

        docs.forEach((doc: any) => {
          const vendorId = doc.da?.id || doc.vendor?.id;
          const criteriaName = normalizeKey(doc.name);

          if (!vendorId || !criteriaName) return;

          if (!map[vendorId]) {
            map[vendorId] = {};
          }
          map[vendorId][criteriaName] = {
            docId: doc.id,
            url: doc.document || ''
          };

          if (!vendorMap.has(vendorId)) {
            vendorMap.set(vendorId, {
              vendor: {
                id: vendorId,
                name: vendorName
              }
            });
          }
        });
      });

      this.vendors = Array.from(vendorMap.values());
    } else {
      for (const vendorName in res) {
        const docs = res[vendorName];

        docs.forEach((doc: any) => {
          const vendorId = doc.vendor.id;
          const criteriaName = normalizeKey(doc.name);

          if (!vendorId || !criteriaName) return;

          if (!map[vendorId]) {
            map[vendorId] = {};
          }
          map[vendorId][criteriaName] = {
            docId: doc.id,
            url: doc.document || ''
          };
        });
      }
    }

    this.documentMap = map;
  });

  this.subscriptions.add(sub);
}

getDocUrl(vendorId: number, criteriaName: string): string | null {
  const normalizeKey = (s: string) =>
    s?.replace(/\r?\n|\r/g, ' ')
      ?.replace(/\s+/g, ' ')
      ?.trim()
      ?.toLowerCase();

  const key = normalizeKey(criteriaName);
  return this.documentMap[vendorId]?.[key]?.url || null;
}


      activeIndex: number | null = null;
  togglePanel(index: number): void {
    this.activeIndex = this.activeIndex === index ? null : index;
  }
}
